import React from 'react';
import FileBase64 from '../util/Input64';
import { Select, Input, AutoComplete, Button, message, Tag, InputNumber, Icon, Tooltip, Radio, Popover, Popconfirm, Modal } from 'antd';
import { Row, Col } from 'reactstrap';
import SERVER_URL from '../Global';
import { Link } from 'react-router-dom';

const { Option } = Select;
const { TextArea } = Input;

message.config({
    top: 50,
    duration: 3,
    maxCount: 5
});

class HandleComp extends React.Component {
    constructor(props) {
        super(props);
        let typo = 1;
        let oggetti = []
        let mandatoryCat = false
        let statusSon = null

        if (this.props.typologyId != null) {
            typo = this.props.typologyId

            if (this.props.typologyId == 20 && this.props.parent != null) {
                statusSon = 3
            } else {
                statusSon = 1
            }
        }

        if (this.props.parent != null) {
            mandatoryCat = true
            this.props.parent.companyCategories.map(cat => {
                oggetti.push({ name: cat.name, id: cat.catId, remove: false })
            })
        }

        this.state = {
            loading: false,
            user: this.props.user,
            categories: this.props.categories,
            tipologies: this.props.tipologies,
            companies: [],
            companiesBrandsSigns: [],
            properties: this.props.properties,
            parentInherit: this.props.parent,
            contactsOffice: ['0'],
            contactsHr: ['0'],
            detailsOff: [],
            contactId: 0,
            offId: 0,
            compName: '',
            lunghezza: false,
            categoriesTag: oggetti,
            categoriesRemoved: [],
            links: [],
            linksRemoved: [],
            companyTypology: typo,
            description: null,
            compCreated: false,
            compId: '',
            companyImage: null,
            offCreated: false,
            officeId: '',
            propId: '',
            hroId: '',
            officeContactText: '',
            position: 'relative',
            producerId: '',
            distributerId: '',
            licenserId: '',
            parentId: this.props.parentId,
            offName: '',
            pIva: null,
            contactHistory: [],
            notes: null,
            propId: 6,
            contactSaved: false,
            linksRemoved: [],
            companySaved: false,
            status: 5,
            hasBeenDeleted: false,
            pivaTooShort: false,
            pivaTooLong: false,
            compNameFieldEmptyAlert: false,
            compCatFieldEmptyAlert: false,
            allSaved: false,
            catName: '',
            compSearch: '',
            showSameName: false,
            sameNameComp: [],
            sameNameAccepted: false,
            acceptSameName: false,
            mandatoryCat: mandatoryCat,
            sort: this.props.sort,
            linkId: null,
            imageType: '',
            mandatoryTyp: true,
            statusSon: statusSon,
            footer: '',
            disabledSaveButton:false,
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleFooterChange = this.handleFooterChange.bind(this);
        this.handlePiva = this.handlePiva.bind(this);
        this.handleCat = this.handleCat.bind(this);
        this.handleTyp = this.handleTyp.bind(this);
        this.saveCompany = this.saveCompany.bind(this);
        this.clearCat = this.clearCat.bind(this);

        this.handleNoteChange = this.handleNoteChange.bind(this);
        this.catNameWritten = this.catNameWritten.bind(this);

        this.handleDist = this.handleDist.bind(this);
        this.handleLicn = this.handleLicn.bind(this);
        this.handleProd = this.handleProd.bind(this);
        this.handleFather = this.handleFather.bind(this);
        this.handleLink = this.handleLink.bind(this);
        this.searchCompany = this.searchCompany.bind(this);
        this.addLink = this.addLink.bind(this);
        this.removeTag = this.removeTag.bind(this);
        this.removeLinkTag = this.removeLinkTag.bind(this);
        this.isNameUnique = this.isNameUnique.bind(this);
        this.saveUniqueName = this.saveUniqueName.bind(this);
        this.checkName = this.checkName.bind(this);
        this.acceptedSameName = this.acceptedSameName.bind(this);
        this.changeToEdit = this.changeToEdit.bind(this);
        this.saveCategories = this.saveCategories.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
    }

    componentDidMount() {
        if (this.state.categories.length < 1) {
            fetch(
                `${SERVER_URL + 'api/companycategory/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "name": '',
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 999,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ categories: res.data }, this.setState({ catLoad: false }));                        
                    } else {
                        this.setState({ categories: [] })
                    }
                })
            
        }

        if (this.state.tipologies.length < 1) {
            //tipologie
            fetch(
                `${SERVER_URL + 'api/translation/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "typeTip": "CompanyTypology",
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ tipologies: res.data });
                    } else {
                        this.setState({ tipologies: [] });
                    }
                })
        }

        if (this.state.properties.length < 1) {
            //proprietà
            fetch(
                `${SERVER_URL + 'api/translation/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "typeTip": "Property",
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ properties: res.data }, this.setState({ propLoad: false }));
                    } else {
                        this.setState({ properties: [] });
                    }
                })
        }

        //companies
        fetch(
            `${SERVER_URL + 'api/company/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "page": 1,
                    "pageSize": 25,
                    "CompanyNameStartWith": '',
                    "TypologyName": "Company",
                    "ExcludeParentId": this.state.compId,
                    "ExcludeId": this.state.compId,
                    "companyStatusList": [5, 1, 0, 4, 3],
                    "ordering": {
                        "orderPropertyName": "companyId",
                        "order": 1
                    }
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ companies: res.data });                    
                }
                else {
                    this.setState({ companies: [] });
                }
            })
    }

    handleNameChange(event) {
        //assegna il nome allo stato, se il nome non è vuoto, toglie i mandatory
        this.setState({ compName: event.target.value, mandatoryCompanyName: true, labelNameVisibility: false, companySaved: false });
        if (event.target.value.length === 0) {
            this.setState({ mandatoryCompanyName: false })
        } else if (event.target.value.length > 0) { 
            this.setState({ labelNameVisibility: true, compNameFieldEmptyAlert: false })
        }
    }

    checkName() {
        //se ci sono altre compagnie con lo stesso nome, mostra la modale con i nomi delle compagnie
        if (this.state.sameNameComp.length > 0 && !this.state.sameNameAccepted) {
            this.setState({ acceptSameName: true })
        }
    }

    acceptedSameName() {
        //ha creato una compagnia con lo stesso nome delle altre, sparisce la modale
        this.setState({ loading: true, showSameName: false, sameNameComp: [], sameNameAccepted: true, acceptSameName: false })
    }

    isNameUnique() {
        //controlla che non ci siano compagnie con lo stesso nome, se ci sono, le assegna allo stato e richiama la checkname
        if (this.state.compName.length > 1 && !this.state.compCreated) {
            fetch(
                `${SERVER_URL + 'api/company/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "CompanyUniqueName": this.state.compName,
                        "page": 1,
                        "companyStatusList": [5, 1, 0, 4, 3],
                        "PageSize": 15
                    })
                }
            ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ sameNameComp: res.data }, this.checkName)
                }
                else {
                    this.setState({ sameNameComp: [] }, this.checkName)
                }
            })
        }
    }

    saveUniqueName(id) {
        //salva la compagnia nonostante condivida il nome con altre compagnie
        if (this.state.compName !== '' && this.state.compCreated == false) {
            this.setState({ loading: true, showSameName: false, sameNameComp: [] })

            let oggetti = []

            this.state.categoriesTag.map(tag => {
                if (!tag.remove) {
                    oggetti.push(tag.id)
                }
            })

            fetch(
                `${SERVER_URL + "api/company"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'name': this.state.compName,
                        "companyTypologyTrValue": this.state.companyTypology,
                        'companyImage': this.state.companyImage,
                        'description': this.state.description,
                        'ProducedBy': this.state.producerId,
                        'DistributedBy': this.state.distributerId,
                        'CompanyLicenserCompanyId': this.state.licenserId,
                        'sort': 1,
                        'companyParentCompanyId': this.state.parentId,
                        'pIva': this.state.pIva,
                        'link': `${this.state.linkId}`,
                        'notes': this.state.notes,
                        "Workflow": this.props.workFlow,
                        "Status": this.state.status,
                        "imageType": this.state.imageType
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ compCreated: true, loading: false, compId: res.data, companySaved: true });
                    document.getElementById("stepWorkflow").style.color = "#1890ff";
                    document.getElementById("stepWorkflow").style.pointerEvents = "initial";

                    this.addLink();

                    this.saveCategories(0)
                })
        } else if (!this.state.mandatoryCat) {
            this.setState({ compCatFieldEmptyAlert: true })
        }

        if (this.state.categoriesTag !== [] && this.state.compName !== '' && this.state.compCreated == true) {
            this.setState({ loading: true })

            let oggetti = []

            this.state.categoriesTag.map(tag => {
                if (!tag.remove) {
                    oggetti.push(tag.id)
                }
            })

            fetch(`${SERVER_URL + 'api/company'}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    'name': `${this.state.compName}`,
                    "companyTypologyTrValue": this.state.companyTypology,
                    'companyImage': this.state.companyImage,
                    'description': this.state.description,
                    'sort': 1,
                    'companyId': `${this.state.compId}`,
                    'ProducedBy': this.state.producerId,
                    'DistributedBy': this.state.distributerId,
                    'CompanyLicenserCompanyId': this.state.licenserId,
                    'companyParentCompanyId': this.state.parentId,
                    'pIva': this.state.pIva,
                    'notes': this.state.notes,
                    "Workflow": this.props.workFlow,
                    "Status": this.state.status,
                    "imageType": this.state.imageType
                })
            }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ loading: false, companySaved: true })

                    this.state.categoriesTag.map(tag => {
                        if (!tag.remove) {
                            fetch(
                                `${SERVER_URL + 'api/BrCompanyCategory'}`, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${this.state.user}`
                                    },
                                    body: JSON.stringify({
                                        'companyId': this.state.compId,
                                        'categoryId': tag.id
                                    })
                                }
                            ).then(response => response.json())
                                .then(res => {
                                    if (res.data === 0) {
                                        fetch(
                                            `${SERVER_URL + 'api/BrCompanyCategory'}`, {
                                                method: 'PUT',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    'Authorization': `Bearer ${this.state.user}`
                                                },
                                                body: JSON.stringify({
                                                    'companyId': this.state.compId,
                                                    'catId': tag.id,
                                                    "isDeleted": false
                                                })
                                            }
                                        )
                                    }
                                })
                        }
                    })

                    this.state.categoriesTag.map(tag => {
                        if (tag.remove) {
                            fetch(
                                `${SERVER_URL + `api/BrCompanyCategory/hard/${this.state.compId}/${tag.id}`}`, {
                                    method: 'DELETE',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${this.state.user}`
                                    }
                                }
                            )
                        } else {
                            fetch(
                                `${SERVER_URL + "api/BrCompanyCategory"}`, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${this.state.user}`
                                    },
                                    body: JSON.stringify({
                                        "CompanyId": this.state.compId,
                                        "CatId": tag.id
                                    })
                                }
                            ).then(response => response.json())
                                .then(res => {
                                    if (res.data === 0) {
                                        fetch(
                                            `${SERVER_URL + 'api/BrCompanyCategory'}`, {
                                                method: 'PUT',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    'Authorization': `Bearer ${this.state.user}`
                                                },
                                                body: JSON.stringify({
                                                    'companyId': this.state.compId,
                                                    'catId': tag.id,
                                                    "isDeleted": false
                                                })
                                            }
                                        )
                                    }
                                })
                        }
                    })

                    this.addLink();
                }
            )
        }
        if (this.state.compName === '' || !this.state.compName) {
            this.setState({ compNameFieldEmptyAlert: true })
        }
        if (this.state.companyTypology === '') {
            this.setState({ compTypFieldEmptyAlert: true })
        }
        if (!this.state.mandatoryCat) {
            this.setState({ compCatFieldEmptyAlert: true })
        }
    }

    changeToEdit() {
        //alla creazione della compagnia, ti porta nel componente edit
        let linkId = this.state.parentId != null ? this.state.parentId : this.state.compId

        window.location = "/edit?id=" + this.state.compId;
    }

    deleteImage() {
        //rimuove l'immagine
        this.setState({ companyImage: null })
    }

    handleDescriptionChange(event) {
        //assegna la descrizione
        if (event.target.value.length === 0) {
            this.setState({ description: null })
        } else {
            this.setState({ description: event.target.value, companySaved: false });
        }
    }

    handleFooterChange(event) {
        //assegna la descrizione
        if (event.target.value.length === 0) {
            this.setState({ footer: null })
        } else {
            this.setState({ footer: event.target.value, companySaved: false });
        }
    }

    handlePiva(event) {
        if (event.target.value.length < 11 && event.target.value.length !== 0) {
            this.setState({ pivaTooShort: true, companySaved: false, pivaTooLong: false });
        } else if (event.target.value.length > 11) {
            this.setState({ pivaTooShort: false, pivaTooLong: true, companySaved: false });
        } else if (event.target.value.length === 11) {
            this.setState({ pIva: event.target.value, pivaTooShort: false, pivaTooLong: false, companySaved: false });
        } else if (event.target.value.length === 0) {
            this.setState({ pivaTooShort: false, pivaTooLong: false, companySaved: false });
        }
    }

    handleNoteChange(event) {
        if (event.target.value.length === 0) {
            this.setState({ notes: null })
        } else {
            this.setState({ notes: event.target.value, companySaved: false });
        }
    }

    catNameWritten(value) {
        this.setState({ catName: value });
    }

    //inizio tag e multiple selection

    handleCat(value) {
        //alla select di una company, la aggiunge alle categoriesTag, quindi mostra un nuovo tag sotto la select
        let deleted = false

        this.state.categoriesRemoved.map(links => {
            if (links == value) {
                deleted = true
            }
        })

        let doppione = false

        this.state.categoriesTag.map(tag => {
            if (tag.id == value) {
                doppione = true
            }
        })

        if (doppione && !deleted) {
            //categoria già selezionata
        } else if (doppione && deleted) {

            let oggetti = []

            this.state.categoriesTag.map(link => {
                if (link.id != value) {
                    oggetti.push({ name: link.name, id: link.id, remove: link.remove })
                }
                else {
                    oggetti.push({ name: link.name, id: link.id, remove: false })
                }
            })

            this.setState({ categoriesTag: oggetti });
        }
        else {
            this.state.categories.map(cat => {
                if (cat.catId == value) {
                    var id = parseInt(value)
                    this.state.categoriesTag.push({ name: cat.name, id: id, remove: false })
                }
            })
        }

        if (this.state.categoriesTag.length > 0) {
            this.setState({ mandatoryCat: true, compCatFieldEmptyAlert: false })
        }

        this.setState({ companySaved: false })
    }

    clearCat() {
        //alla select di una categoria, svuota la select
        this.setState({ catName: '' })
    }

    removeTag(id) {
        //rimuove una categoria dal categoriesTag e rimuove il tag sotto la select
        this.state.categoriesRemoved.push(id)

        let oggetti = []

        this.state.categoriesTag.map(link => {
            if (link.id != id) {
                oggetti.push({ name: link.name, id: link.id, remove: link.remove })
            }
            else {
                oggetti.push({ name: link.name, id: link.id, remove: true })
            }
        })

        let atLeastOneShow = false
        oggetti.map(tag => {
            if (!tag.remove) {
                atLeastOneShow = true
            }
        })

        if (!atLeastOneShow) {
            this.setState({ mandatoryCat: false })
        }

        this.setState({ categoriesTag: oggetti, companySaved: false });
    }

    handleLink(value) {
        //aggiunge  i link a links
        let deleted = false

        this.state.linksRemoved.map(links => {
            if (links == value) {
                deleted = true
            }
        })

        let doppione = false

        this.state.links.map(tag => {
            if (tag.id == value) {
                doppione = true
            }
        })

        if (doppione && !deleted) {
            //link già selezionato
        }
        else if (doppione && deleted) {

            let oggetti = []

            this.state.links.map(link => {
                if (link.id != value) {
                    oggetti.push({ name: link.name, id: link.id, remove: link.remove })
                }
                else {
                    oggetti.push({ name: link.name, id: link.id, remove: false })
                }
            })

            this.setState({ links: oggetti });
        }
        else {
            fetch(
                `${SERVER_URL + 'api/company/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "companyId": value,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 1,
                        "pageSizeOptions": null,
                        "ExcludeParentId": this.state.compId,
                        "ExcludeId": this.state.compId,
                        "companyStatusList": [5, 1, 0, 4, 3],
                        "CompanyNameStartWith": '',
                        "firstItemNumber": 0,
                        "ordering": {
                            "orderPropertyName": "companyId",
                            "order": -1
                        },
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.state.links.push({ name: res.data[0].name, id: value, remove: false })

                    this.setState({links: this.state.links})
                })
        }
    }

    removeLinkTag(id) {

        this.state.linksRemoved.push(id)

        let oggetti = []

        this.state.links.map(link => {
            if (link.id != id) {
                oggetti.push({ name: link.name, id: link.id, remove: link.remove })
            }
            else {
                oggetti.push({ name: link.name, id: link.id, remove: true })
            }
        })

        this.setState({ links: oggetti });
    };

    //fine tag e multiple selection

    handleTyp(value) {
        //assegna la tipologia, se non ha un parent e non è una company, fa partire il mandatory
        this.setState({ companyTypology: value, mandatoryTyp: true, companySaved: false, compTypFieldEmptyAlert: false })

        if (value != 1 && this.state.parentId == null) {
            this.setState({ sonNoParent: true })
        } else {
            this.setState({ sonNoParent: false })
        }

        if (value == 20 && this.state.status == 5) {
            this.setState({ statusSon: 3 })
        }
    }

    handleFather(value) {
        //assegna il padre, se il parent è null e non è una company, fa partire il mandatory
        this.setState({ parentId: value, companySaved: false })

        if (this.state.companyTypology != 1 && value == null) {
            this.setState({ sonNoParent: true })
        } else {
            this.setState({ sonNoParent: false })
        }
    }

    switchChange = e => {
        //assenga lo stato, se lo stato non è "padre", lo assegna ai figli
        if (e.target.value == 5 || e.target.value == 0 || e.target.value == 2) {

            if (e.target.value == 5 && this.state.parentId != null) {
                this.setState({ status: e.target.value, statusSon: 1, companySaved: false });
            } else {
                this.setState({ status: e.target.value, companySaved: false });
            }

        } else {
            this.setState({ status: 5, statusSon: e.target.value, companySaved: false });
        }
    };

    handleSort(value) {
        //assegna il sort
        this.setState({ sort: value })
    }

    saveCompany() {
        //salva la compagnia, creandola o editandola
        this.setState({ disabledSaveButton: true })
        let status = this.state.status
        if (status == 5 && this.state.parentId != null) { status = this.state.statusSon }
        if (this.state.mandatoryCat && this.state.sameNameComp.length === 0) {
            if (this.state.compName !== '' && this.state.compCreated === false) {
                this.setState({ loading: true })

                let oggetti = []

                this.state.categoriesTag.map(tag => {
                    if (!tag.remove) {
                        oggetti.push(tag.id)
                    }
                })

                fetch(
                    `${SERVER_URL + "api/company"}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        },
                        body: JSON.stringify({
                            'name': this.state.compName,
                            "companyTypologyTrValue": this.state.companyTypology,
                            'companyImage': this.state.companyImage,
                            'description': this.state.description,
                            'CompanyProducerCompanyId': this.state.producerId,
                            'CompanyDistributorCompanyId': this.state.distributerId,
                            'CompanyLicenserCompanyId': this.state.licenserId,
                            'sort': this.state.sort,
                            'companyParentCompanyId': this.state.parentId,
                            'pIva': this.state.pIva,
                            'link': this.state.linkId,
                            'notes': this.state.notes,
                            "Workflow": this.props.workFlow,
                            "Status": status,
                            "imageType": this.state.imageType,
                            "footer": this.state.footer
                        })
                    }
                ).then(response => response.json())
                    .then(res => {
                        this.setState({ compCreated: true, loading: false, compId: res.data, companySaved: true, disabledSaveButton: false });
                        document.getElementById("stepWorkflow").style.color = "#1890ff";
                        document.getElementById("stepWorkflow").style.pointerEvents = "initial";

                        this.addLink();

                        this.saveCategories(0)
                    })
            }

            if (this.state.compName === '' || !this.state.compName) {
                this.setState({ compNameFieldEmptyAlert: true })
            }
            if (this.state.companyTypology === '') {
                this.setState({ compTypFieldEmptyAlert: true })
            }
            if (!this.state.mandatoryCat) {
                this.setState({ compCatFieldEmptyAlert: true })
            }
        } else if (!this.state.mandatoryCat) {
            this.setState({ compCatFieldEmptyAlert: true })
        }
        else {
            this.setState({showSameName: true})
        }
    }

    saveCategories(i) {
        let tag = this.state.categoriesTag[i]

        if (!tag.remove) {
            fetch(
                `${SERVER_URL + 'api/BrCompanyCategory'}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    'companyId': this.state.compId,
                    'catId': tag.id
                })
            }).then(response => response.json())
                .then(res => {
                    if (res.data === 0) {
                        fetch(
                            `${SERVER_URL + 'api/BrCompanyCategory'}`, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${this.state.user}`
                            },
                            body: JSON.stringify({
                                'companyId': this.state.compId,
                                'catId': tag.id,
                                "isDeleted": false
                            })
                        }
                        )
                    }
                    if (this.state.categoriesTag.length == i + 1) {
                        this.changeToEdit()
                    } else {
                        this.saveCategories(i + 1)
                    }
                })
        } else {
            fetch(
                `${SERVER_URL + `api/BrCompanyCategory/hard/${this.state.compId}/${tag.id}`}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                }
            }).then(response => response.json())
                .then(res => {
                    if (this.state.categoriesTag.length == i + 1) {
                        this.changeToEdit()
                    } else {
                        this.saveCategories(i + 1)
                    }
                })
        }
    }

    searchCompany(value, conditioner) {
        //i risultati delle varie select
        this.setState({compSearch: value})
        if (value == undefined) {
            //companies
            fetch(
                `${SERVER_URL + 'api/company/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 15,
                        "companyStatusList": [5, 1, 0, 4, 3],
                        "pageSizeOptions": null,
                        "ExcludeParentId": this.state.compId,
                        "ExcludeId": this.state.compId,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    var noSelf = []
                    var noSelfBS = []

                    res.data.map(comp => {
                        if (comp.companyTypologyTrValue == 1) {
                            if (comp.companyId !== this.state.compId) {
                                noSelf.push(comp)
                            }
                        }
                        if (comp.companyId !== this.state.compId) {
                            noSelfBS.push(comp)
                        }
                    })

                    this.setState({ companies: noSelf, companiesBrandsSigns: noSelfBS, parentId: null });

                    if (this.state.companyTypology != 1 && value == undefined) {
                        this.setState({ sonNoParent: true })
                    }
                })
        } else if (value.length >= 3 || value.length === 0) {
            //companies
            fetch(
                `${SERVER_URL + 'api/company/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "CompanyNameStartWith": `${value + "%"}`,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 15,
                        "companyStatusList": [5, 1, 0, 4, 3],
                        "ExcludeParentId": this.state.compId,
                        "ExcludeId": this.state.compId,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {

                        var noSelf = []
                        var noSelfBS = []

                        res.data.map(comp => {
                            if (comp.companyTypologyTrValue == 1) {
                                if (comp.companyId !== this.state.compId) {
                                    noSelf.push(comp)
                                }
                            }
                            if (comp.companyId !== this.state.compId) {
                                noSelfBS.push(comp)
                            }
                        })

                        this.setState({ companies: noSelf, companiesBrandsSigns: noSelfBS });
                    } else {
                        this.setState({ companies: [], companiesBrandsSigns: [] });
                    }
                })

            if (value.length == 0) {
                if (conditioner == 1) {
                    this.setState({ producerId: null })
                } else if (conditioner == 2) {
                    this.setState({ distributerId: null })
                } else if (conditioner == 3) {
                    this.setState({ licenserId: null })
                } else if (conditioner == 4) {
                    this.setState({ parentId: null })
                }
            }
        }
    }

    getFiles(files) {
        //seleziona i file, partendo dalla callback di input64
        if (files.length !== 0) {
            this.setState({ companyImage: files.base64, imageType: files.type, companySaved: false });
        } else {
            this.setState({ companyImage: '' });
        }
    }

    //marchi

    handleProd(value) {
        //producer
        this.setState({ producerId: value, companySaved: false });
    }

    handleDist(value) {
        //distributer
        this.setState({ distributerId: value, companySaved: false });
    }

    handleLicn(value) {
        this.setState({ licenserId: value, companySaved: false });
    }

    //fine marchi

    addLink() {
        //salva o elimina i link in base a se sono rimossi o no
        this.state.links.map(link => {
            if (!link.remove) {
                fetch(
                    `${SERVER_URL + "api/companylink"}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        },
                        body: JSON.stringify({
                            "CompanyId": this.state.compId,
                            "CompanyLinkToCompanyId": link.id
                        })
                    }
                )
            }
            else {
                fetch(
                    `${SERVER_URL + `api/companylink/hard/${this.state.compId}/${link.id}`}`, {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        }
                    }
                )
            }
        })
    }

    render() {
        let mandatory1 = !this.state.mandatoryCompanyName ? <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" style={{ left: '0px', marginLeft: '10px', top: "8px" }} /></Tooltip> : <Icon type="check-circle" style={{ left: '0px', marginLeft: '10px', top: "8px" }} />

        let mandatory3 = !this.state.mandatoryCat ? <Tooltip title="This field is mandatory"><Icon className="iconSelect" type="exclamation-circle" style={{ left: '0px', marginLeft: '10px' }} /></Tooltip> : <Icon className="iconSelect" type="check-circle" style={{ left: '0px', marginLeft: '10px' }} />

        let companySaved = this.state.companySaved && this.state.mandatoryCompanyName ? true : false

        let listacat = this.state.categories.map(cat =>
            <Option key={cat.catId}>{cat.name}</Option>
        )

        let tagCat = this.state.categoriesTag.map(tag => {
            if (!tag.remove) {
                return (
                    <Tag className="cat" closable key={tag.id} onClick={() => this.removeTag(tag.id)}>
                        <span>{tag.name}</span>
                    </Tag>
                )
            }
        })

        let linkCat = this.state.links.map(link => {
            if (!link.remove) {
                return (
                    <Tag className="link" closable key={link.id} onClick={() => this.removeLinkTag(link.id)}>
                        <span>{link.name}</span>
                    </Tag>
                )
            }
        })

        let listacompany = this.state.companies.map(comp => {
            if (comp.companyId !== this.state.compId) {
                return (<Option key={comp.companyId}>{comp.name}</Option>)
            }
        })

        let listacompanyBS = this.state.companiesBrandsSigns.map(comp => {
            if (comp.companyId !== this.state.compId) {
                return (<Option key={comp.companyId}>{comp.name}</Option>)
            }
        })

        let showParent = this.props.parent != null ? <p><b>{this.props.parent.name}</b></p> :
            <AutoComplete
                dataSource={listacompany}
                style={{ width: '100%' }}
                onSelect={this.handleFather}
                onChange={(value) => this.searchCompany(value, 4)}
                placeholder="Parent"
                allowClear
                className="handleTyp"
            />

        let acceptUniqueName = this.state.acceptSameName && !this.state.sameNameAccepted ?
            <Modal
                className="modale"
                title="This name already exists. Continue?"
                onCancel={() => this.setState({ acceptSameName: false })}
                visible={this.state.acceptSameName}
                onOk={this.acceptedSameName}
                maskClosable={false}
            >
                <p>Click one of the links below to start editing that company</p>

                <ul className="sameNameComp">
                    {this.state.sameNameComp.map(comp =>
                        <li key={comp.companyId}><Link to={"/edit?id=" + comp.companyId} >{comp.name} - {comp.brCompanyCategories.map(cat => <span className="catWizardLink" key={cat.catId}>{cat.companyCategories.name}</span>)}</Link></li>
                    )}
                </ul>
            </Modal>
            : ""

        let notUniqueName = this.state.showSameName && !this.state.sameNameAccepted ?

            <Modal
                className="modale"
                title="This name already exists. Continue?"
                onCancel={() => this.setState({ showSameName: false })}
                visible={this.state.showSameName}
                onOk={this.saveUniqueName}
                maskClosable={false}
            >
                <p>Click one of the links below to start editing that company</p>

                <ul className="sameNameComp">
                    {this.state.sameNameComp.map(comp =>
                        <li key={comp.companyId}><Link to={"/edit?id=" + comp.companyId} >{comp.name} - {comp.brCompanyCategories.map(cat => <span className="catWizardLink" key={cat.catId}>{cat.companyCategories.name}</span>)}</Link></li>
                    )}
                </ul>
            </Modal>

            : ""

        let listatyp = this.state.tipologies.map(tip =>
            <Option key={tip.value}>{tip.text}</Option>
        )

        let mandatory2 = !this.state.mandatoryTyp ? <Tooltip title="This field is mandatory"><Icon className="iconSelect" type="exclamation-circle" style={{ left: '0px', marginLeft: '10px' }} /></Tooltip> : <Icon className="iconSelect" type="check-circle" style={{ left: '0px', marginLeft: '10px' }} />

        let zonaMarchioTOrF = this.state.companyTypology == 2 /*brand*/ || this.state.companyTypology == 17 /*sign*/ ? true : false

        let brandOrSign = this.state.companyTypology == 2 ? <h4>Brand's data:</h4> : <h4>Sign's data:</h4>

        let imageContent = <div><p className="fakeLink" style={{ display: 'block' }} onClick={this.deleteImage}><Icon style={{ color: 'red' }} type="close" /> Remove image</p><img className="popoverImage" src={'data:' + this.state.imageType + ';base64,' + this.state.companyImage} /></div>

        let iconImage = this.state.companyImage !== null && this.state.companyImage !== '' ? <Popover content={imageContent}><div style={{ backgroundImage: 'url(' + `${'data:' + this.state.imageType + ';base64,' + this.state.companyImage}` + ')' }} className="trueWizardImage"></div></Popover> : <div className="fakeWizardImage">{this.state.compName.charAt(0)}</div>

        let companyTypologyText = this.state.companyTypology == 1 ? "Company" : this.state.companyTypology == 2 ? "Brand" : this.state.companyTypology == 17 ? "Sign" : this.state.companyTypology == 20 ? "Department" : this.state.companyTypology

        let mandatoryAreNotMet = <p><Icon type="exclamation-circle" style={{ color: 'red' }} /> One or more mandatory fields are empty</p>

        let saveButtonSwitch = this.state.sonNoParent || this.state.compName === '' || !this.state.compName || this.state.companyTypology === '' || !this.state.mandatoryCat ? <Popover content={mandatoryAreNotMet}><Button disabled className="saveButtonHrWizard" icon="save"> Save {companyTypologyText}</Button></Popover> : this.state.allSaved ? <Popover content={mandatoryAreNotMet}><Button disabled className="saveButtonHrWizard" icon="save"> Save {companyTypologyText}</Button></Popover> : <Button disabled={this.state.disabledSaveButton} onClick={this.saveCompany} className="saveButtonHrWizard" icon="save" > Save {companyTypologyText}</Button>

        let partitaIVa = this.state.companyTypology == 2 || this.state.companyTypology == 17 || this.state.companyTypology == 20 ? <Popover content={"A " + companyTypologyText + " can't have a Vat Number"}><Input autoComplete="new-password" disabled className={"anticonNoTop pIva" + this.state.pivaTooShort + this.state.pivaTooLong} onChange={this.handlePiva} style={{ width: '100%', height: '52px' }} placeholder="Vat number" /></Popover> : <Input autoComplete="new-password" className={"anticonNoTop pIva" + this.state.pivaTooShort + this.state.pivaTooLong} onChange={this.handlePiva} style={{ width: '100%', height: '52px' }} placeholder="Vat number" />

        let chooseOneFFS = this.state.companyTypology != 1 && this.state.parentId == null ? <Tooltip title="This field is mandatory"><Icon className="iconSelect" type="exclamation-circle" style={{ left: '0px', marginLeft: '10px' }} /></Tooltip> : this.state.companyTypology != 1 && this.state.parentId != null ? <Icon className="iconSelect" type="check-circle" style={{ left: '0px', marginLeft: '10px' }} /> : ''

        let secondRadioGroup = this.state.status == 5 && this.state.parentId != null ?
            <Radio.Group onChange={this.switchChange} value={this.state.statusSon}>
                <Radio.Button value={3}>Inside Owner</Radio.Button>
                <Radio.Button value={1}>Alone</Radio.Button>
                <Radio.Button value={4}>Everywhere</Radio.Button>
            </Radio.Group> : <Radio.Group disabled onChange={this.switchChange} value={this.state.statusSon}>
                <Radio.Button value={3}>Inside Owner</Radio.Button>
                <Radio.Button value={1}>Alone</Radio.Button>
                <Radio.Button value={4}>Everywhere</Radio.Button>
            </Radio.Group>

        let extraButtons = this.state.parentInherit ?
            <div style={{ height:'40px', display:'inline-flex'}}>
                <p style={{ padding: 13 }}><Icon type="arrow-right" /></p>
                <div style={{ height: '40px' }}>
                    {secondRadioGroup}
                </div>
            </div> : null

        return (
            <Col className={"wizardFields wizardCompany" + " " + this.props.workFlow + " hasBeenDeleted" + this.state.hasBeenDeleted} sm="12">
                <h6 style={{ padding: '0 15px' }}>{companyTypologyText} details</h6>
                <Row className={"companySavedBox" + companySaved}>
                    <InputNumber autoComplete="new-password" min={1} max={1000} className="sortingInput" value={this.state.sort} onChange={this.handleSort} />

                    <Col sm="6">
                        <div className="wizardCompanyCreation">
                            <div className="compNameAndStatus">
                                <div className="wizardCompName">
                                    <h4 className="visibleLabeltrue">
                                        <Tooltip placement="topLeft" title={"Insert the " + companyTypologyText + " Name here"}>
                                            <Icon className="iconSelect" type="info-circle" />
                                        </Tooltip>
                                        {companyTypologyText} Name:
                                    </h4>
                                    <div style={{ display: "flex" }}>
                                        <Input autoComplete="new-password" onBlur={this.isNameUnique} className={"baseInput" + " name" + this.props.i + " companyNameWizard companyNameValidation" + this.state.compNameFieldEmptyAlert} placeholder= {companyTypologyText + " Name:"} allowClear={true} onChange={this.handleNameChange} style={{ height: '40px' }} />
                                        {mandatory1}
                                    </div>
                                    <p style={{ color: 'red', float: "left", position: "absolute", display: this.state.sameNameComp.length < 1 ? "none" : "block" }} className={this}>This name is already been used by another company</p>
                                </div>
                                <div className="statusBox">                                    

                                    <Tooltip placement="topLeft" title="Insert here the company logo, 600px x 600px recommended maximum dimensions">
                                        <h4><Icon type="info-circle" /> Company Logo:</h4>
                                    </Tooltip>

                                    <div className="wizardInputs imgUpload" style={{ display:'inline-flex' }}>
                                        <FileBase64 onDone={this.getFiles.bind(this)} />
                                        {iconImage}
                                    </div>
                                    <span id="wrongSize" className="warningWizard">Warning, file size is too big (max 150 kb)</span>
                                    <span id="wrongExtension" className="warningWizard">Warning, only .png, .jpg, .jpeg and .svg accepted</span>
                                    
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col sm="6">

                        <div className="firstBlock">
                            <div className="blockTypology">
                                <Tooltip placement="topLeft" title="Select a Typology">
                                    <h4><Icon type="info-circle" /> Typology:</h4>
                                </Tooltip>

                                <div style={{ display: 'flex', height: '35px' }}>
                                    <Select
                                        mode="single"
                                        className={'selectWizard darkSelect companyTypValidation' + this.state.compTypFieldEmptyAlert}
                                        placeholder="Typology"
                                        style={{ width: '100%', fontWeight: '500' }}
                                        onChange={this.handleTyp}
                                        defaultValue={companyTypologyText}
                                    >
                                        {listatyp}
                                    </Select>
                                </div>

                            </div>
                            <div className="blockCategory">
                                <Tooltip placement="topLeft" title="Select one or more categories related to the company">
                                    <h4><Icon type="info-circle" /> Category:</h4>
                                </Tooltip>

                                <div style={{ display: 'flex' }}>

                                    <AutoComplete
                                        dataSource={listacat}
                                        onBlur={this.clearCat}
                                        style={{ width: '100%'}}
                                        onSelect={this.handleCat}
                                        id="clearOnSelect"
                                        placeholder="Categories"
                                        value={this.state.catName}
                                        onSearch={this.catNameWritten}
                                        onChange={this.clearCat}
                                        className={"selectCategory darkSelect companyCatValidation" + this.state.compCatFieldEmptyAlert}
                                        filterOption={(inputValue, option) =>
                                            option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                    />

                                    {mandatory3}
                                </div>
                                <div className="linkLink categoryTags">
                                    {tagCat}
                                </div>
                            </div>

                        </div>

                    </Col>

                    <Col sm="12" className={"zonaMarchio" + zonaMarchioTOrF} style={{ paddingLeft: '14px', paddingRight: '14px' }}>
                        <hr style={{ marginTop: '10px', marginBottom: '0px' }} />

                        <div className="brandBox">

                            <div style={{ padding: '0px 15px', display: 'inline-flex', width: '100%' }}>

                                <div className="brandLabel brandLabelWidth">
                                    {brandOrSign}
                                </div>

                                <div className="brandSelectWidth">
                                    <div style={{ display: 'block', width: '100%' }}>
                                        <Tooltip placement="topLeft" title="If empty, office name will be the same as company name">
                                            <h4><Icon type="info-circle" /> Producer:</h4>
                                        </Tooltip>

                                        <AutoComplete
                                            dataSource={listacompany}
                                            style={{ width: '90%', display: 'inline-flex' }}
                                            onSelect={this.handleProd}
                                            onChange={(value) => this.searchCompany(value, 1)}
                                            placeholder="Producer"
                                        />

                                    </div>

                                    <div style={{ display: 'block', width: '100%' }}>

                                        <Tooltip placement="topLeft" title="If empty, office name will be the same as company name">
                                            <h4><Icon type="info-circle" /> Distributer:</h4>
                                        </Tooltip>

                                        <AutoComplete
                                            dataSource={listacompany}
                                            style={{ width: '90%', display: 'inline-flex' }}
                                            onSelect={this.handleDist}
                                            onChange={(value) => this.searchCompany(value, 2)}
                                            placeholder="Distributer"
                                        />

                                    </div>

                                    <div style={{ display: 'block', width: '100%' }}>

                                        <Tooltip placement="topLeft" title="If empty, office name will be the same as company name">
                                            <h4><Icon type="info-circle" /> Licenser:</h4>
                                        </Tooltip>

                                        <AutoComplete
                                            dataSource={listacompany}
                                            style={{ width: '90%', display: 'inline-flex' }}
                                            onSelect={this.handleLicn}
                                            onChange={(value) => this.searchCompany(value, 3)}
                                            placeholder="Licenser"
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr style={{ marginTop: '0px', marginBottom: '15px' }} />
                    </Col>

                    <Col sm="12" style={{ display: 'inline-flex', padding: '0px' }}>

                        <Col sm="6">
                            <div className="wizardCompanyCreation">

                                <div className="secondBlock">

                                    <div className="createCompImgBlock">

                                        <Tooltip placement="topLeft" title="If the company has a parent company, select it here">
                                            <h4><Icon type="info-circle" /> Parent/Owner:</h4>
                                        </Tooltip>

                                        <div style={{ display: 'flex' }}>
                                            {showParent}
                                            {chooseOneFFS}
                                        </div>

                                    </div>

                                    <div className="createCompParentBlock">

                                        <Tooltip placement="topLeft" title="Associate this company to another one">
                                            <h4><Icon type="info-circle" /> Reference:</h4>
                                        </Tooltip>

                                        <AutoComplete
                                            dataSource={listacompanyBS}
                                            style={{ width: '100%' }}
                                            onSelect={this.handleLink}
                                            onChange={this.searchCompany}
                                            placeholder="References"
                                        />

                                        <div className="linkLink">
                                            {linkCat}
                                        </div>

                                    </div>

                                </div>

                                <div className="thirdBlock leftCol">
                                    <Row>
                                        <Col sm="6">
                                            <Tooltip placement="topLeft" title="Write any additional information about the company">
                                                <h4 id="h4Desc" className="mt-20">
                                                    <Icon type="info-circle" /> Description:
                                                </h4>
                                            </Tooltip>
                                            <TextArea className="textareaWizard" autosize={{ minRows: 2, maxRows: 15 }} style={{ width: '100%' }} placeholder="Description" onChange={this.handleDescriptionChange} />
                                        </Col>

                                        <Col sm="6">
                                            <Tooltip placement="topLeft" title="Write any additional information about the company">
                                                <h4 id="h4Desc" className="mt-20">
                                                    <Icon type="info-circle" /> Footer:
                                                </h4>
                                            </Tooltip>
                                            <TextArea className="textareaWizard" autosize={{ minRows: 2, maxRows: 15 }} style={{ width: '100%' }} placeholder="Footer" onChange={this.handleFooterChange} />
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>

                        <Col sm="6">

                            <div className="secondBlock" style={{ marginBottom: '2.5em' }}>
                                <div style={{ width: '100%' }}>
                                    <Tooltip placement="topLeft" title="Let the company be visible or hidden in the companies list">
                                        <h4 className="visibleLabeltrue"><Icon type="info-circle" /> Status:</h4>
                                    </Tooltip>

                                    <div style={{ width: '100%', display: 'flex' }}>
                                        <div style={{ height: '40px' }}>
                                            <Radio.Group onChange={this.switchChange} value={this.state.status}>
                                                <Radio.Button value={0}>Hidden</Radio.Button>
                                                <Radio.Button value={2}>Disabled</Radio.Button>
                                                <Radio.Button value={5}>Visible</Radio.Button>
                                            </Radio.Group>
                                        </div>
                                        {extraButtons}
                                    </div>
                                </div>
                            </div>

                            <div className="thirdBlock rightCol">

                                <div className="sharingIsCaring">

                                    <Tooltip placement="topLeft" title="VAT number">
                                        <h4><Icon type="info-circle" /> Vat number:</h4>
                                    </Tooltip>
                                    {partitaIVa}
                                    <p className={"pIvaShort" + this.state.pivaTooShort}>Input must be equal to 11 numbers</p>
                                    <p className={"pIvaLong" + this.state.pivaTooLong}>Input must be equal to 11 numbers</p>
                                </div>

                                <div className="sharingIsCaring">

                                    <Tooltip placement="topLeft" title="This field will not be shown in the company card, it is for internal use only">

                                        <h4><Icon type="info-circle" /> Internal Notes:</h4>
                                    </Tooltip>

                                    <TextArea autosize={{ minRows: 2, maxRows: 15 }} style={{ width: '100%' }} placeholder="Notes" onChange={this.handleNoteChange} />

                                </div>

                            </div>

                            {/*
                            <h6>Roles and HR details</h6>
                            {this.state.contactsHr.map(i => (
                                <div key={i} id={'contacthr' + i}>
                                    {offCreated}
                                </div>
                            ))
                            }
                            {addNewRole}
                            */}
                        </Col>

                    </Col>

                    <div className="buttonsCreateCompany">
                        {saveButtonSwitch}
                    </div>

                </Row>

                <Row>
                    {notUniqueName}
                    {acceptUniqueName}
                </Row>
            </Col>

        );
    }
}

export default HandleComp;


// WEBPACK FOOTER //
// ./src/Wizard/HandleComp.js